import { useState } from 'react';
import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import './LazyMarketing.css';

const LinkedInScraper = () => {
  const [searchParams, setSearchParams] = useState({
    jobTitle: '',
    company: '',
    location: '',
    industry: '',
    companySize: '',
    keywords: ''
  });
  const [isSearching, setIsSearching] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [recentSearches, setRecentSearches] = useState([
    { id: 1, query: 'VP Marketing at SaaS companies', count: 847, date: '2h ago' },
    { id: 2, query: 'CTOs in fintech startups', count: 324, date: '1d ago' },
    { id: 3, query: 'Sales Directors in healthcare', count: 562, date: '2d ago' },
  ]);

  const handleSearch = async () => {
    setIsSearching(true);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));

    setResults([
      { id: 1, name: 'Sarah Johnson', title: 'VP of Marketing', company: 'TechFlow Inc', location: 'San Francisco, CA', connections: '500+', email: 'sarah.j@techflow.com', enriched: true },
      { id: 2, name: 'Michael Chen', title: 'Head of Growth', company: 'ScaleUp AI', location: 'New York, NY', connections: '500+', email: null, enriched: false },
      { id: 3, name: 'Emily Rodriguez', title: 'CMO', company: 'DataDriven Co', location: 'Austin, TX', connections: '500+', email: 'emily@datadriven.co', enriched: true },
      { id: 4, name: 'David Kim', title: 'Marketing Director', company: 'CloudFirst', location: 'Seattle, WA', connections: '432', email: null, enriched: false },
      { id: 5, name: 'Jessica Brown', title: 'VP Marketing & Sales', company: 'FinanceHub', location: 'Chicago, IL', connections: '500+', email: 'jbrown@financehub.com', enriched: true },
      { id: 6, name: 'Alex Thompson', title: 'Growth Lead', company: 'SaaS Startup', location: 'Remote', connections: '287', email: null, enriched: false },
    ]);
    setIsSearching(false);
  };

  const handleSelectLead = (leadId) => {
    setSelectedLeads(prev =>
      prev.includes(leadId)
        ? prev.filter(id => id !== leadId)
        : [...prev, leadId]
    );
  };

  const handleSelectAll = () => {
    if (selectedLeads.length === results.length) {
      setSelectedLeads([]);
    } else {
      setSelectedLeads(results.map(r => r.id));
    }
  };

  const handleEnrichSelected = async () => {
    // API call to enrich emails
    alert(`Enriching ${selectedLeads.length} leads...`);
  };

  const handleAddToCampaign = () => {
    alert(`Adding ${selectedLeads.length} leads to campaign...`);
  };

  const stats = [
    { label: 'Total Scraped', value: '12,847', change: '+1,234 this week', changeType: 'positive' },
    { label: 'Emails Found', value: '8,923', change: '69% enrichment rate', changeType: 'positive' },
    { label: 'Active Campaigns', value: '4', change: 'Using scraped leads', changeType: 'neutral' },
    { label: 'Credits Remaining', value: '4,500', change: 'Resets in 12 days', changeType: 'neutral' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <div>
          <h1 className="lm-page-title">LinkedIn Lead Scraper</h1>
          <p className="lm-page-subtitle">Find and enrich leads from LinkedIn</p>
        </div>
        <div className="header-actions">
          <Button variant="secondary" icon="upload">Import CSV</Button>
          <Button variant="primary" icon="download">Export Leads</Button>
        </div>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      {/* Search Form */}
      <div className="lm-section">
        <h3 className="lm-section-title">Search LinkedIn</h3>
        <div className="search-form">
          <div className="search-row">
            <div className="form-group">
              <label>Job Title</label>
              <input
                type="text"
                placeholder="e.g., VP Marketing, CMO, Head of Growth"
                value={searchParams.jobTitle}
                onChange={(e) => setSearchParams({...searchParams, jobTitle: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Company</label>
              <input
                type="text"
                placeholder="e.g., Google, Microsoft, or leave blank"
                value={searchParams.company}
                onChange={(e) => setSearchParams({...searchParams, company: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                placeholder="e.g., San Francisco, United States"
                value={searchParams.location}
                onChange={(e) => setSearchParams({...searchParams, location: e.target.value})}
              />
            </div>
          </div>
          <div className="search-row">
            <div className="form-group">
              <label>Industry</label>
              <select
                value={searchParams.industry}
                onChange={(e) => setSearchParams({...searchParams, industry: e.target.value})}
              >
                <option value="">All Industries</option>
                <option value="saas">SaaS / Software</option>
                <option value="fintech">Fintech</option>
                <option value="healthcare">Healthcare</option>
                <option value="ecommerce">E-commerce</option>
                <option value="marketing">Marketing / Advertising</option>
              </select>
            </div>
            <div className="form-group">
              <label>Company Size</label>
              <select
                value={searchParams.companySize}
                onChange={(e) => setSearchParams({...searchParams, companySize: e.target.value})}
              >
                <option value="">Any Size</option>
                <option value="1-10">1-10 employees</option>
                <option value="11-50">11-50 employees</option>
                <option value="51-200">51-200 employees</option>
                <option value="201-500">201-500 employees</option>
                <option value="501+">501+ employees</option>
              </select>
            </div>
            <div className="form-group">
              <label>Keywords</label>
              <input
                type="text"
                placeholder="Additional keywords..."
                value={searchParams.keywords}
                onChange={(e) => setSearchParams({...searchParams, keywords: e.target.value})}
              />
            </div>
          </div>
          <div className="search-actions">
            <Button variant="primary" icon="search" onClick={handleSearch} disabled={isSearching}>
              {isSearching ? 'Searching...' : 'Search LinkedIn'}
            </Button>
            <span className="search-hint">Uses 1 credit per 10 results</span>
          </div>
        </div>
      </div>

      {/* Recent Searches */}
      {results.length === 0 && (
        <div className="lm-section">
          <h3 className="lm-section-title">Recent Searches</h3>
          <div className="recent-searches">
            {recentSearches.map(search => (
              <div key={search.id} className="recent-search-item">
                <div className="search-query">
                  <Icon name="search" />
                  <span>{search.query}</span>
                </div>
                <div className="search-meta">
                  <span>{search.count} results</span>
                  <span>{search.date}</span>
                </div>
                <Button variant="secondary" size="sm">Run Again</Button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Results */}
      {results.length > 0 && (
        <div className="lm-section">
          <div className="lm-section-header">
            <h3 className="lm-section-title">Results ({results.length})</h3>
            <div className="results-actions">
              <Button
                variant="secondary"
                size="sm"
                onClick={handleSelectAll}
              >
                {selectedLeads.length === results.length ? 'Deselect All' : 'Select All'}
              </Button>
              {selectedLeads.length > 0 && (
                <>
                  <Button variant="secondary" size="sm" icon="mail" onClick={handleEnrichSelected}>
                    Enrich Emails ({selectedLeads.length})
                  </Button>
                  <Button variant="primary" size="sm" icon="plus" onClick={handleAddToCampaign}>
                    Add to Campaign
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="leads-table">
            <div className="leads-table-header">
              <span className="col-checkbox"></span>
              <span>Name</span>
              <span>Title</span>
              <span>Company</span>
              <span>Location</span>
              <span>Email</span>
              <span>Actions</span>
            </div>
            {results.map(lead => (
              <div key={lead.id} className={`leads-table-row ${selectedLeads.includes(lead.id) ? 'selected' : ''}`}>
                <span className="col-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedLeads.includes(lead.id)}
                    onChange={() => handleSelectLead(lead.id)}
                  />
                </span>
                <div className="lead-name">
                  <span className="name">{lead.name}</span>
                  <span className="connections">{lead.connections} connections</span>
                </div>
                <span className="lead-title">{lead.title}</span>
                <span className="lead-company">{lead.company}</span>
                <span className="lead-location">{lead.location}</span>
                <span className={`lead-email ${lead.enriched ? 'found' : 'not-found'}`}>
                  {lead.email || (
                    <button className="enrich-btn">
                      <Icon name="search" /> Find Email
                    </button>
                  )}
                </span>
                <div className="lead-actions">
                  <button className="action-btn" title="View Profile">
                    <Icon name="external-link" />
                  </button>
                  <button className="action-btn" title="Add to List">
                    <Icon name="plus" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LinkedInScraper;
